// JS Framework and CSS Framework
import Vue from 'vue';
import Vuetify from 'vuetify';

// Routing, state management, i18n and validation
import store from '@/store';
import router from '@/router';
import i18n from '@/i18n';

// Directives
import { directive as onClickOutsideDirective } from 'vue-on-click-outside';
import focusDirective from '@/directives/focus';

// Filters
import * as filters from '@/helpers/filters';

// Default
import App from '@/App';

// Register everything
Vue.use(Vuetify);

Vue.directive('on-click-outside', onClickOutsideDirective);
Vue.directive('focus', focusDirective);

Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key]);
});

// Disable annoying message
Vue.config.productionTip = false;

/* eslint-disable no-new */
window.Vue = new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js